export default "__VITE_ASSET__MbDKq3tr__"